import React, { Component } from "react";
import "./signin.css";
import { auth } from "./firebase";
import { Link } from "react-router-dom";
import editor from "./editor.jpg";
import academ from "./academ.jpg";
import bio from "./bio.jpg";
import chil from "./chil.jpg";
import fic from "./fic.jpg";
import life from "./layf.jpg";
import polit from "./polit.jpg";
import fan from "./fan.jpg";
import most from "./popula.jpg";
import art from "./art.jpg";
import bus from "./busines.jpg";
import envi from "./envi.jpg";
import heal from "./heal.jpg";
import grow from "./grow.jpg";
import reli from "./reli.jpg";
import tec from "./tec.jpg";
import market from "./pm.png";
import mac from "./mac.jpg";
import not from "./not.jpg";
import pdflogo from "./pdflog.png";

class Signin extends Component {
  state = {
    status: "login",
    email: "",
    password: "",
  };
  handlelogin = () => {
    auth.signInWithEmailAndPassword(this.state.email, this.state.password)
    .then(()=>{
      window.location.href = "/"
    })
    .catch((err)=>{
      alert(err.message)
    })
  };
  render() {
    return (
      <React.Fragment>
        <div className="bek">
          <div className="mainpart container">
            <div className="leftprem container">
              <div className="kvadratt container">
                <div className="widthga">
                  <p className="signinword">Sign in</p> <br />
                  <div className="regg widthga">
                    <p>EMAIL ADDRESS</p>
                    <input
                      onChange={(event) => {
                        this.setState({ email: event.target.value });
                      }}
                      className="emailga"
                      type="text"
                      placeholder="Email Address"
                    />
                  </div>
                  <div className="passs widthga">
                    <p className="fg">PASSWORD</p>
                    <input
                      onChange={(event) => {
                        this.setState({ password: event.target.value });
                      }}
                      className="emailga"
                      type="password"
                      placeholder="Password"
                    />
                    <p className="forgot">Forgot Password?</p>
                  </div>
                </div>
                <div className="checkb widthga">
                  <div className="ckk">
                    <input className="chkbo" type="checkbox" />{" "}
                    <p>Remember me</p>
                  </div>
                  <div>
                    <button onClick={this.handlelogin}>Sign In</button>
                  </div>
                </div>
                <div className="sozacc widthga">
                  <Link to="/createaccount">
                    <button className="createacc">Create Account</button>
                  </Link>
                </div>
              </div>
            </div>
            <div className="rightprem">
              <div className="klarall">
                <p>
                  <span>Pdfdrive:hope</span> Give books away. Get books you
                  wont.
                </p>
                <div className="hamakitob">
                  <div>
                    <a href="https://www.pdfdrive.com/category/113">
                      <span className="poo">
                        <img src={editor} alt="" /> <p>Editor's Picks</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/6">
                      <span className="poo">
                        <img src={academ} alt="" /> <p>Academic & Education</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/16">
                      <span className="poo">
                        <img src={bio} alt="" /> <p>Biograhpy</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/17">
                      <span className="poo">
                        <img src={chil} alt="" /> <p>Children & Youth</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/11">
                      <span className="poo">
                        <img src={fic} alt="" /> <p>Fiction & Literature</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/19">
                      <span className="poo">
                        <img src={life} alt="" /> <p>Lifestyle</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/15">
                      <span className="poo">
                        <img src={polit} alt="" /> <p>Politics & Laws</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/15">
                      <span className="poo">
                        <img src={fan} alt="" /> <p>Science & Research</p>
                      </span>
                    </a>
                  </div>
                  <div>
                    <a href="https://www.pdfdrive.com/category/112">
                      <span className="pooo">
                        <img src={most} alt="" /> <p>Most Popular</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/1">
                      <span className="pooo">
                        <img src={art} alt="" /> <p>Art</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/3">
                      <span className="pooo">
                        <img src={bus} alt="" /> <p>Business & Career</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/18">
                      <span className="pooo">
                        <img src={envi} alt="" /> <p>Environment</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/8">
                      <span className="pooo">
                        <img src={heal} alt="" /> <p>Health & Fitness</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/4">
                      <span className="pooo">
                        <img src={grow} alt="" /> <p>Personal Growth</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/10">
                      <span className="pooo">
                        <img src={reli} alt="" /> <p>Religion</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/5">
                      <span className="pooo">
                        <img src={tec} alt="" /> <p>Technology</p>
                      </span>
                    </a>
                  </div>
                </div>
                <p className="inbo">
                  Get Top Trending Free Books in Your Inbox
                </p>
                <span className="emalga">
                  <input type="text" placeholder="Enter you email" />
                  <button>Subscribe</button>
                </span>
                <a href="https://www.pdfdrive.com/app">
                  <img className="mar" src={market} alt="" />
                </a>
                <p className="trendingtoday">Trending Today</p>
                <span className="macb">
                  <img src={mac} alt="" />
                  <p className="perfor">
                    Performance is King: Join The World's Leading <br />
                    Native Ad Network-Revcontent
                  </p>
                  <p className="rev">Revcontent</p>
                </span>
                <span className="macb">
                  <img src={not} alt="" />
                  <p className="perfor">
                    Join Revcontent: Join The World's Fastest <br /> Growing
                    Native Ad Network-Revcontent
                  </p>
                  <p className="rev">Revcontent</p>
                </span>
              </div>
            </div>
          </div>
          <div className="ddd">
            <div className="donatefooter container">
              <div className="donin">
                <img className="pdflog" src={pdflogo} alt="" />

                <div>
                  <p>Company</p>
                  <a href="https://www.pdfdrive.com/home/about">About</a>
                  <br />
                  <a href="https://www.pdfdrive.com/app">Mobile App</a> <br />
                  <a href="https://www.pdfdrive.com/home/terms">
                    Terms & Privacy
                  </a>
                </div>
                <div>
                  <p>Social</p>
                  <a href="https://twitter.com/pdfdrive">Twitter</a>
                  <br />
                  <a href="https://www.facebook.com/pdfdrive">Facebook</a>{" "}
                  <br />
                  <span className="donher">
                    <a href="https://www.pdfdrive.com/donate">Donate</a>
                    <i className="fa fa-heart"></i>
                  </span>
                </div>
                <div>
                  <p>Help</p>
                  <a href="https://www.pdfdrive.com/home/contact">Contact Us</a>
                  <br />
                  <a href="https://www.pdfdrive.com/home/contact">
                    Feedback
                  </a>{" "}
                  <br />
                  <a href="https://www.pdfdrive.com/home/dmca">
                    DMCA & Copyright
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default Signin;
